module.exports = __webpack_public_path__ + "static/media/icon-menu-services.6b7f60f0.svg";